var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueHeadful',{attrs:{"title":_vm.$store.getters['pageHead/getTitle'],"description":_vm.$store.getters['pageHead/getDescription']}})
}
var staticRenderFns = []

export { render, staticRenderFns }